<template>
	<section>

		<main class="container mt-12 py-12">
			<div class="row">
				<div class="col mt-24 text-center">
					<h2 class="my-12 py-8">{{ $t('checkin.title') }}</h2>

					<form class="needs-validation" novalidate>
						<div class="row">
							<div class="col mb-20">
								<label for="zipcode">{{ $t('checkin.zip.enterzipcode') }}</label>
								<input v-model="guestZip" @focus="show" data-layout="compact" type="text" class="form-control" id="zipcode" :placeholder="$t('checkin.zip.input-placeholder')" required>
								<div v-if="showError" class="invalided-feedback">{{ $t('checkin.zip.error') }}</div>
							</div>
						</div>

						<div class="row pt-3">
							<div class="col-md-3 text-left">
								<a @click.prevent="lastStep" class="btn btn-secondary btn-prev">{{ $t('checkin.cancel') }}</a>
							</div>
							<div class="col-md-6 pt-3 dots">
								<p><span class="dot active"></span> <span class="dot"></span> <span class="dot"></span></p>
							</div>
							<div class="col-md-3 text-right">
								<button @click.prevent="nextStep" class="btn btn-primary btn-next" type="submit">{{ $t('checkin.next') }}</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</main>
	</section>
</template>

<script>

    import axios from 'axios'

    export default {
        props: [],
        data: function () {
            return {
                guestZip: null,
				showError: false
            }
        },
        methods: {
            lastStep() {
	            this.$parent.direction = false;
                this.$parent.guest = null;
                this.$parent.component = 'CheckinStart';
            },
            nextStep() {
	            this.$parent.visible = false;
				let isGuestCheck = false;
                let self = this;
                if(this.guestZip == self.$parent.guest.zip) {
                    self.showError = false;
                    self.$parent.component = 'CheckinForm';
                } else {
                    self.showError = true;
				}
            },

	        /** Keyboard Events **/
	        accept(text) {
		        this.$parent.accept(text);
	        },
	        show(e) {
		        this.$parent.show(e);
	        },

	        hide() {
		        this.$parent.hide();
	        },

	        next() {
		        this.$parent.next();
	        }


        },
        components: {}
    }
</script>

<style scoped lang="scss">

</style>
